export default {"src":"/_next/static/media/backend.6ec4b263.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};